var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.siteId === 'fuz')?_c('logo-fuzenet'):(_vm.siteId === 'pre')?_c('logo-premium'):(_vm.siteId === 'hisp')?_c('logo-hisp'):(_vm.siteId === 'qnet')?_c('logo-quantum'):_c('logo-uniti')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }